module.exports = __webpack_public_path__ + "img/bag-icon.b0c0eb55.svg";